import gql from 'graphql-tag';

import {PricingGroup} from './pricing-group.fragment';

export const UpdatePricingGroups = gql`
    mutation UpdatePricingGroups($institutionSetId: InstitutionSetId!, $pricingGroups: [PricingGroupInput!]!) {
        finance {
            pricingGroups {
                setPricingGroups(institutionSetId: $institutionSetId, pricingGroups: $pricingGroups) {
                    ...PricingGroup
                }
            }
        }
    }

    ${PricingGroup}
`;
